<template>
  <div v-if="showModuloForm === false">
    <MarketingModules></MarketingModules>
  </div>

  <CarrosselListagem
    v-else
    tipo-conteudo="STATIC_IMAGES"
    base-route="/fornecedor/customizacao/carrossel"
    carousel-type-variant="type1"
  />
</template>

<script>
import MarketingModules from "@/components/MarketingModules";
import CarrosselListagem from "./CarrosselListagem";
import { ModulesEnum } from "@/store/actions/modulesEnum";
import { mapGetters } from "vuex";

export default {
  components: {
    MarketingModules,
    CarrosselListagem
  },
  data() {
    return {
      modulosForm: [ModulesEnum.TODOS]
    };
  },
  computed: {
    ...mapGetters(["moduloFornecedorAtivo"]),
    showModuloForm() {
      return this.moduloFornecedorAtivo(this.modulosForm);
    }
  }
};
</script>
